import Skeleton from "react-loading-skeleton";

const ProductDetailsLoading = () => {
	return (
		<section className="container mx-auto max-w-6xl p-6">
			<div className="mb-4 flex items-start justify-between">
				<div>
					<Skeleton count={1} className="mb-2 h-20 w-20 rounded-full" />
					<Skeleton count={1} className="block h-4 md:w-56" />
					<Skeleton count={1} className="block h-8 md:w-72" />
				</div>
				<div className="hidden items-start justify-start gap-4 md:flex">
					<div>
						<Skeleton count={1} className="mb-1 h-16 w-32 md:w-56" />
						<Skeleton count={1} className="mb-1 h-16 w-32 md:w-56" />
						<Skeleton count={1} className="mb-1 h-16 w-32 md:w-56" />
					</div>
					<Skeleton count={1} className="h-56 w-32" />
				</div>
			</div>
			<Skeleton count={1} height={480} />
		</section>
	);
};

export default ProductDetailsLoading;
